import React, { createContext, useContext, useState, useRef } from 'react';
import { APP } from '../config/appConfig';

const NotificationContext = createContext(null);

let idSeed = 1;

export function NotificationProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  function push(type, title, msg, duration) {
    const id = idSeed++;
    const t = { id, type, title, msg };
    setToasts(prev => [...prev, t]);
    timers.current[id] = setTimeout(() => {
      remove(id);
    }, duration || APP.toastDurationMs);
    return id;
  }

  function remove(id) {
    setToasts(prev => prev.filter(t => t.id !== id));
    if (timers.current[id]) {
      clearTimeout(timers.current[id]);
      delete timers.current[id];
    }
  }

  const api = {
    toasts,
    remove,
    info:    (title, msg, d) => push('info', title, msg, d),
    success: (title, msg, d) => push('success', title, msg, d),
    error:   (title, msg, d) => push('error', title, msg, d),
    warn:    (title, msg, d) => push('warn', title, msg, d)
  };

  return <NotificationContext.Provider value={api}>{children}</NotificationContext.Provider>;
}

export function useNotify() {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotify outside NotificationProvider');
  return ctx;
}
